module.exports = __webpack_public_path__ + "img/btn3.b99f5938.png";